import moment from 'moment'

export const formatDate = (date) =>
    moment(date).format('DD/MM/YY HH:mm') + 'hs.'
